import * as React from 'react'
import * as firebase from 'firebase/app'
import 'firebase/firestore'
import 'firebase/functions'
import './VodDetail.css'
import TeacherList from '../../teacher/teacher-list/TeacherList'
import { DailyVodConfig, TeacherConfig, VideoType, VodCategory } from '../../../configs/stream-entities'
import Calendar from 'react-calendar'
import { PacmanLoader } from 'react-spinners'
import 'react-s-alert/dist/s-alert-default.css'
import 'react-s-alert/dist/s-alert-css-effects/slide.css'
import Alert from 'react-s-alert'
import VideoCategoriesList from '../categories/Video-categories-list'
import {
    Button,
    Paper,
    TextField,
} from "@material-ui/core";

class VodDetailProps {
    public vodId: string
}

class VodDetailState extends DailyVodConfig {
    public forceReset: boolean = false
    public showLoader: boolean = false
    public type: VideoType;
}

class VodDetail extends React.Component<VodDetailProps, VodDetailState> {

    private formRef: React.RefObject<HTMLFormElement>

    constructor(props: VodDetailProps) {
        super(props)
        const newState = new VodDetailState()
        newState.id = props.vodId
        newState.categories = ['']
        newState.publishDate = new Date()
        this.state = newState
        this.formRef = React.createRef<HTMLFormElement>()
        this.onURLUpdate = this.onURLUpdate.bind(this)
        this.onTeacherSelected = this.onTeacherSelected.bind(this)
        this.onCalendarChange = this.onCalendarChange.bind(this)
        this.onDurationChange = this.onDurationChange.bind(this)
        this.ontypeChange = this.ontypeChange.bind(this);
        this.onAvailableInHomePageChange = this.onAvailableInHomePageChange.bind(this);
        this.onCategorySelected = this.onCategorySelected.bind(this)
        this.onDescriptionChange = this.onDescriptionChange.bind(this)
        this.onAddCategoryClicked = this.onAddCategoryClicked.bind(this)
        this.onPriorityChange = this.onPriorityChange.bind(this)
        this.onTitleChange = this.onTitleChange.bind(this)
        this.onSubmit = this.onSubmit.bind(this)
        this.resetForm = this.resetForm.bind(this)
    }

    public componentWillUpdate(nextProps: VodDetailProps, nextState: VodDetailState) {
        if (this.props.vodId !== nextProps.vodId) {
            firebase.firestore().collection('vod').doc('daily').collection('videos').doc(nextProps.vodId).get().then(snapshot => {

                Object.assign(nextState, snapshot.data())
                nextState.publishDate = snapshot.data()!.publishDate.toDate()
                nextState.id = snapshot.id
                nextState.forceReset = false
                nextState.analyticsType = snapshot.data()!.analyticsType || "";
                nextState.theme = snapshot.data()!.theme || "";
                nextState.availableInHomePage = snapshot.data()!.availableInHomePage || false;
                nextState.coverImageUrl = snapshot.data()!.coverImageUrl || "";
                this.setState(nextState)
            })
        }
    }

    public render() {
        return (
            <Paper className="VodDetail">

                <Button onClick={this.resetForm} variant="contained">New</Button>

                <form ref={this.formRef} onSubmit={this.onSubmit}>

                    {
                        !!this.state.id && <label className='id-info'>Video Id: {this.state.id}</label>
                    }

                    <label htmlFor="vodURL">Video URL</label>
                    <TextField type="text" name="vodURL" placeholder="e.g.: https://vimeo.com/326359542" variant="outlined"
                               onChange={this.onURLUpdate} required={true} value={this.state.vimeoURL}  />

                    <label htmlFor="">Teacher</label>
                    <TeacherList isMultiple={false} defaultValue={this.state.teacherId} onItemSelected={this.onTeacherSelected} />

                    <label>Cover Image Url</label>
                    <TextField variant="outlined" type="text" name="coverImageUrl"
                               value={this.state.coverImageUrl}
                               onChange={ event => this.setState({coverImageUrl: event.target.value}) } />

                    <label htmlFor="vodDuration">Duration (minutes)</label>
                    <TextField variant="outlined" type="number" name="vodDuration"
                               required={true} value={this.state.duration} onChange={this.onDurationChange} />

                    <span>Categories</span>
                    <Button onClick={this.onAddCategoryClicked} variant="contained">Add Category</Button>
                    {this.state.categories.map((value: string, index: number) =>
                        <VideoCategoriesList key={value} onItemSelected={this.onCategorySelected} isMultiple={false} defaultValue={this.state.categories[index]} />
                    )}

                    <fieldset>
                        <legend>Video Type</legend>
                        <input name="type" type="radio" id="typeDJ" value={VideoType.DAILY} onChange={this.ontypeChange} checked={this.state.type === VideoType.DAILY ? true : false} />
                        <span>DAILY JOURNEY</span><br />
                        <input name="type" type="radio" id="typeVOD" value={VideoType.EVERYDAY} onChange={this.ontypeChange} checked={this.state.type === VideoType.EVERYDAY ? true : false} />
                        <span>VOD</span><br />
                    </fieldset>

                    <label>Title</label>
                    <TextField
                        variant="outlined" name="title" type="text" required={true}
                        value={this.state.description} onChange={this.onTitleChange} />

                    <label>Description</label>
                    <TextField
                        rows={3} name="vodDesc" required={true} multiline variant="outlined"
                        value={this.state.descriptionLong} onChange={this.onDescriptionChange} />

                    {
                        this.state.type === VideoType.EVERYDAY &&
                        <div>
                            <label>Theme</label>
                            <TextField
                                variant="outlined" name="theme" type="text" required={false}
                                value={this.state.theme} onChange={(event) => this.setState({theme: event.target.value})}/>
                        </div>
                    }

                    <label htmlFor="priority">Priority (the smaller the number to more important)</label>
                    <TextField
                        type="number" name="priority" variant="outlined"
                        onChange={this.onPriorityChange}
                        required={true} value={this.state.priority} />

                    {
                        this.state.type === VideoType.EVERYDAY &&
                        <fieldset>
                            <legend>Available in Home Page</legend>
                            <input name="availableInHomePage" type="radio" value="1" onChange={this.onAvailableInHomePageChange} checked={this.state.availableInHomePage} />
                            <span>Yes</span><br />
                            <input name="availableInHomePage" type="radio" value="0" onChange={this.onAvailableInHomePageChange} checked={!this.state.availableInHomePage} />
                            <span>No</span><br />
                        </fieldset>
                    }
                    {
                        this.state.type === VideoType.DAILY &&
                        <div>
                            <label>Analytics Type (mini, wake-up, daily-journey, etc)</label>
                            <TextField
                                type="text" name="analyticsType" variant="outlined"
                                onChange={ (event) => this.setState({ analyticsType: event.target.value })}
                                required={true} value={this.state.analyticsType} />
                        </div>

                    }
                    {this.state.type === VideoType.DAILY &&
                        <div>
                            <label>Publishing Date</label>
                            <Calendar value={this.state.publishDate} onChange={this.onCalendarChange} />
                        </div>
                    }
                    {!this.state.showLoader ?
                        <Button type="submit" variant="contained">Submit</Button> :
                        <div className='popup'>
                            <PacmanLoader css={'display: inline-block;'} loading={true} />
                        </div>}
                </form>
                <Alert stack={true} />
            </Paper>
        )
    }

    private onPriorityChange(event: React.ChangeEvent<HTMLInputElement>) {
        this.setState({ priority: Number(event.target.value) })
    }

    private onAddCategoryClicked() {
        const cats = this.state.categories
        cats.push('')
        this.setState({ categories: cats })
    }

    private onTitleChange(event: React.ChangeEvent<HTMLInputElement>) {
        const title = event.target.value
        this.setState({ description: title })
    }

    private onDescriptionChange(event: React.ChangeEvent<HTMLTextAreaElement>) {
        this.setState({ descriptionLong: event.target.value })
    }

    private onCategorySelected(cat: VodCategory) {
        const categories = this.state.categories
        const hasCategory = categories.indexOf(cat.id)
        if (hasCategory < 0) {
            if (categories[categories.length - 1] === '') {
                categories[categories.length - 1] = cat.id
            } else {
                categories.push(cat.id)
            }
        }
        this.setState({ 'categories': categories })
    }

    private ontypeChange(event: React.ChangeEvent<HTMLInputElement>) {
        const type = VideoType[event.target.value]
        this.setState({ 'type': type })
    }

    private onAvailableInHomePageChange(event: React.ChangeEvent<HTMLInputElement>) {
        const isAvailableInHomePage = event.target.value === "1";
        this.setState({ availableInHomePage: isAvailableInHomePage });
    }

    private onDurationChange(event: React.ChangeEvent<HTMLInputElement>) {
        this.setState({ duration: Number(event.currentTarget.value) })
    }
    private onCalendarChange(date: Date) {
        this.setState({ publishDate: date })
    }

    private onURLUpdate(event: React.ChangeEvent<HTMLInputElement>) {
        this.setState({ vimeoURL: event.currentTarget.value })
    }

    private onTeacherSelected(doc: TeacherConfig) {
        this.setState({ teacherId: doc.uuid })
    }

    private resetForm(_: any) {
        const newState = new VodDetailState()
        newState.forceReset = true
        this.setState(newState)
    }

    private onSubmit(event: React.FormEvent) {
        event.preventDefault()
        if (this.formRef.current!.checkValidity()) {
            const vodCollectionRef = firebase.firestore().collection('vod').doc('daily').collection('videos')
            const request = new DailyVodConfig()
            let requestTask: Promise<DailyVodConfig>
            request.duration = this.state.duration
            // TODO: remove the publishDate when old version is done
            request.publishDate = this.state.type === VideoType.EVERYDAY ? new Date("01-01-2019") : this.state.publishDate
            request.teacherId = this.state.teacherId;
            request.vimeoURL = this.state.vimeoURL;
            request.categories = this.state.categories;
            request.description = this.state.description;
            request.descriptionLong = this.state.descriptionLong;
            request.priority = this.state.priority;
            request.type = this.state.type;
            request.theme = this.state.theme;
            request.availableInHomePage = this.state.availableInHomePage || false;
            request.coverImageUrl = this.state.coverImageUrl;
            request.analyticsType = this.state.analyticsType;
            if (this.state.id === undefined || this.state.id.length < 1) {
                requestTask = vodCollectionRef.add(Object.assign({}, request)).then(result => {
                    request.id = result.id
                    return request
                })
            } else {
                request.id = this.state.id
                requestTask = vodCollectionRef.doc(request.id).update(Object.assign({}, request)).then(_ => {
                    return request
                })
            }
            this.setState({ showLoader: true })
            requestTask.then(result => {
                const setPlaybackURL = firebase.functions().httpsCallable('setVimeoPlayBackURL')
                this.setState({ id: result.id })
                return setPlaybackURL({ vimeoURL: result.vimeoURL, videoId: result.id })
            }).then(httpResult => {
                console.log(httpResult)
                if (httpResult.data.result === 'Success') {
                    Alert.success('Daily Journey added!', {
                        effect: 'slide',
                        position: 'top',
                        timeout: 5000
                    })
                }
                this.setState({ showLoader: false })
            }).catch(err => {
                Alert.error(err.message, {
                    effect: 'slide',
                    position: 'top',
                    timeout: 5000
                })
                this.setState({ showLoader: false })
            })
        }
    }
}

export default VodDetail


// WEBPACK FOOTER //
// ./src/components/daily-video/vod-detail/VodDetail.tsx